import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ag-widget-layout',
  templateUrl: './widget-layout.component.html',
  styleUrls: ['./widget-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WidgetLayoutComponent {
  constructor() {}
}
